<template>
  <div class="layout">
    <top ref="top"></top>
    <div class="uk-grid">
      <leftnav></leftnav>
      <!--主框架-->
      <div class="uk-width-medium-4-5 uk-width-mid-4-5 uk-width-small-1-1">
        <keep-alive>
          <router-view ref="main" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view  ref="main" v-if="!$route.meta.keepAlive"></router-view>
        <div class="common_panel"><tips></tips></div>        
        <div class="uk-width-1-1"><bottomtips ref="submitAction"></bottomtips></div>  
      </div>
    </div>

    <div class="uk-overlay-panel uk-flex uk-flex-center uk-flex-middle uk-overlay-panel-loading" v-if="isload == 1"> 
        <div class="loading">
          <div class="load"><span class="uk-icon-spinner uk-icon-spin"></span></div>
        </div>
      </div>       
  </div>
</template>
<script>
import top from "@/components/common/top";
import leftnav from "@/components/common/leftnav";
import bottomtips from '@/components/information/bottomtips'
import tips from '@/components/information/tips'
import system from '@/components/common/resouces/system'
import {mapState} from 'vuex'



export default {
  name: 'layout',
  components: {top,leftnav,tips,bottomtips
  },
  data() {
    return {
      
    };
  },
  created(){

  },

  computed: {
    domain(){
      return this.$store.state.home.domain;
    },
    publicdomain(){
        return this.$store.state.home.publicdomain;
    },
    userInfo() {
      return this.$store.state.home.userInfo;
    },    
    merchant_list(){
      return this.$store.state.home.merchant_list;
    },
    currentMerchantNo(){
      return this.$store.state.home.current_merchant_no; 
    },  
    currentMerchant(){
      return this.$store.state.home.current_merchant      
    },    
    merchantCount(){
      return this.$store.state.home.merchantCount
    },
    flag(){
      return this.$store.state.home.flag
    }, 
    isload(){
      return this.$store.state.home.isload
    }
  },

  mounted: function(){

    $('html').removeClass('uk-modal-page');
    let name = this.$route.name
    this.currname = name 

    if(this.$store.state.home.is_web_load == 0){                
      this.$store.state.home.isload = 1 //刷新页面重新请求成功前，将遮照打开
    }


    //vuex中flag 开关为true 则开始请求用户接口 
    if(this.$store.state.home.flag == 1){   
        this.$store.state.home.isload = 1         
        this.$store.state.home.current_merchant = []      
        this.$store.state.home.current_merchant_no = ''
        this.getSystemConfig();
    }else{
      let list = this.merchant_list                
      if(Object.keys(list).length == 0){
        if(this.currname !== 'set'){
          this.$router.push({
            path:'/Merchant/create_merchant',                  
          });
        }
        return    
      }       
    }

    
  
    if(this.$store.state.home.flag == 0){
      console.log('请求完毕')
      if(this.userInfo.is_bind_secret == 0){
        if(this.currname !== 'set' ){
          this.$router.replace('/Error/need_bind'); 
        }
        return
      }   
    }
    
  },
  activated:function(){      

  },

  
  methods: {

    chooseLang2(){
      this.$refs.main.chooseLang();
    },

    chooseLang() {    
      this.getUserInfo();
    },

    getSystemConfig(){
      let url = this.publicdomain +'plat/SystemConfig/getData'
    

      this.$get(url).then((res)=>{
          // console.log(res.data)
          if(res.data.errcode == 0){                  
              this.$store.commit('set_config',res.data.data);    
                var lang = localStorage.getItem("language");                        
               if(lang == 'zh-cn'){      
                document.title = res.data.data.plat_slogan['zh-cn']
              }else{
                document.title = res.data.data.plat_slogan['en-us']
              }      
              this.getUserInfo();                 
          }else{
               this.alert(res.data.errcode,res.data.errmsg);  
          }         
      });
    },

      //获取用户信息
    getUserInfo(){ 
      this.$store.state.home.current_merchant = []      
      this.$store.state.home.current_merchant_no = ''         
      let url = this.domain+'/UserAuth/getInfo'
      this.$get(url).then((res)=>{                      
        // console.log(res.data);   
        if(res.data.errcode == 0){ 
          this.$store.state.home.is_web_load = 1
          // this.$store.dispatch('getUserInfo',res.data.data); //vuex 储存相关用户信息 
          this.$store.commit('SetUserInfo',res.data.data)
          window.localStorage.setItem('language', res.data.data.user_info.language); 
          this.$i18n.locale = res.data.data.user_info.language                
          //this.setTitle();
          if(res.data.data.user_info.is_bind_secret == 0){  
            // console.log(res.data.data.user_info.is_bind_secret)
            if(this.currname !== 'set' ){
              this.$router.replace('/Error/need_bind'); 
            }               
            this.$store.state.home.isload = 0     //刷新页面重新请求成功后，将遮照关闭
            return
          }else{
              let list = res.data.data.merchant_list    
              let merchant_list = []
              for(let k in list){
                  merchant_list.push(list[k]);
              }
              this.$store.state.home.merchantCount = list.length;
              if(merchant_list.length  == 0){
                    // console.log('暂没有商户号！！！');
                if(this.currname !== 'set' ){
                    this.$router.replace('/Merchant/create_merchant');                         
                      this.chooseLang2();                 
                    }
                    this.$store.state.home.isload = 0 //刷新页面重新请求成功后，将遮照关闭                    
                    return
                  }else{ 
                    var no = localStorage.getItem("current_merchant_no");
                    if(no){                      
                      let current_merchant =  list[no]
                      this.$store.commit('setMerchantInfo',no);
                      this.chooseLang2();
                    }else{
                      //查询是否有默认状态的商户号
                      let default_no = ''
                      for(let k in merchant_list){
                          if(merchant_list[k].merchant_show_order == 1){
                              default_no = merchant_list[k].merchant_no                                        
                          }
                      }       

                      if(default_no){
                          localStorage.setItem('current_merchant_no', default_no) 
                          this.$store.commit('setMerchantInfo',default_no);
                          this.chooseLang2();                                                           
                      }else{
                          let current_merchant_no =  merchant_list[0].merchant_no
                          localStorage.setItem('current_merchant_no', current_merchant_no)
                          let current_merchant =  merchant_list[0]                                    
                          this.$store.commit('setMerchantInfo',current_merchant_no);
                          this.chooseLang2();                                                    
                      }  



                    }             
                    this.$store.state.home.isload = 0    //刷新页面重新请求成功后，将遮照关闭
                  }
              }   
        }else{
          this.$store.state.home.is_web_load = 1
          this.alert(res.data.errcode,res.data.errmsg);
        // this.setTitle();                
        }
      });
    },

    //如果没有绑定，跳转绑定页面
    no_bind_route(){
      if(this.currname !== 'set' ){
        this.$router.replace('/error/need_bind'); 
      }               
      this.$store.state.home.isload = 0     //刷新页面重新请求成功后，将遮照关闭
    },


    getMerchantCount(list){     
      let arr = []   
      for(let k in list){
        arr.push(list[k])
      }
      return arr.length
      // console.log(arr);
    },     
 
  
    subStrText(v,n){            
        let val = this.common.subStrLangText(v,n);
        return val
    },
    setTitle() {
                            
    },


    


  
   

    openModal(){
    },
   
   
    
 
    
 

    jump(v){
      this.$router.push({
        path:'/merchant_list',        
      })
    },
   

    NumFormat(value) {
      if(value){
        let intPartFormat = this.common.NumFormat(value);
        return intPartFormat;  
      }      
    },

    
    

    getLastStr(v){
      if(v){
        return "("+v.substr(-5)+")";
      }   
      
    },



    subStrText(v) {
      let val = this.common.subStrText(v);
      return val;
    },

    subStrLangTexts(v, n) {
      let val = this.common.subStrLangText(v, n);
      return val;
    },

    //提示
    alert(v,msg){      
      if(localStorage.getItem('access_token')){
        this.$refs.submitAction.alert(v,msg);                   
      }
    },
  }
};
</script>
<style scoped lang="scss">
.uk-panel {
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/index.vue